import React from 'react';
import zhConvertor from 'zhconvertor';

const tr = (text) =>
  localStorage.getItem('lang') !== 'zh_TW' ? zhConvertor.t2s(text) : text;

const ETHNIC_GROUPS = [
  { key: 'malay', label: '巫裔', color: '#4e79a7' },
  { key: 'cina', label: '华裔', color: '#e15759' },
  { key: 'india', label: '印裔', color: '#f28e2b' },
  { key: 'bpsabah', label: '沙巴土著', color: '#76b7b2' },
  { key: 'lain', label: '其他', color: '#9c9c9c' },
];

const SeatDemographics = ({ regPercent, electorate }) => {
  if (!electorate) return null;

  const segments = regPercent ? ETHNIC_GROUPS
    .map((g) => ({ ...g, pct: parseFloat(regPercent[g.key]) || 0 }))
    .filter((g) => g.pct > 0) : null;

  return (
    <>
      <div className="seat_info_grid">
        <div className="seat_info_left">{tr('选民人数')}</div>
        <div className="seat_info_right">
          {parseInt(electorate).toLocaleString()}
        </div>
      </div>
      {regPercent && <div className="seat_info_grid">
        <div className="seat_info_left">{tr('选民结构')}</div>
        <div className="seat_info_right">
          <div className="demographic_bar">
            {segments.map((g) => (
              <div
                key={g.key}
                className="demographic_segment"
                style={{ width: `${g.pct}%`, backgroundColor: g.color }}
                title={`${tr(g.label)} ${g.pct}%`}
              />
            ))}
          </div>
          <div className="demographic_legend">
            {segments.map((g) => (
              <span key={g.key} className="demographic_legend_item">
                <span
                  className="demographic_legend_swatch"
                  style={{ backgroundColor: g.color }}
                />
                {tr(g.label)} {g.pct}%
              </span>
            ))}
          </div>
        </div>
      </div>
      }
    </>
  );
};

export default SeatDemographics;
